var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filters'),_vm._v(" "),_c('listOfProducts',{attrs:{"products":_vm.getProducts(
    _vm.$route.path === '/' ? 'all' : _vm.$route.params.category,
    _vm.$route.path === '/' ? null : _vm.$route.params.discipline
    )}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9659bb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllProducts.vue
// module id = null
// module chunks = 